import { WelcomeType } from './types';
import WelcomeStep from './WelcomeStep';

export { WelcomeType };
export default WelcomeStep;
